<template>
  <v-container>
    <v-container class="noPaddingBtm">
      <v-card flat>
        <v-row>
          <v-col cols="5" class="headerTitle headerGroup noPaddingBtm">
            <v-row>
              <v-card-title style="height: 40px;">物件グループ</v-card-title>
              <v-col class="noPaddingBtm">
                <ryou-select class="ryouSelectStyle" :items="dynamicItems" :itemText="'build_group_name'"
                  :itemValue="'build_group_id'" v-model="selectOptionValue" :value="selectOptionValue">
                </ryou-select>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="3" class="noPaddingBtm">
            <v-card-title class="OfferTitle">
              <h2>提供メニュー</h2>
            </v-card-title>
          </v-col>

          <v-col cols="4" class="noPaddingBtm">
            <v-row>
              <v-col cols="4" style="padding: 0px;">
                <v-card-title style="padding: 16px 0px 16px 45px">メニュー取込み</v-card-title>
              </v-col>
              <v-col cols="4" style="padding: 0px 0px 12px;">
                <v-form ref="p2Form" v-model="p2Form" lazy-validation>
                  <v-file-input label="登録ファイル" v-model="chosenFile" :rules="inputRulesFile" truncate-length="14">
                  </v-file-input>
                </v-form>
              </v-col>
              <v-col cols="4" style="padding: 0px 12px;">
                <v-card-actions>
                  <ryou-black-btn :label="'アップロード'" :handlerClick="importFile" :iconCls="'mdi-file-upload'">
                  </ryou-black-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <v-container>
      <v-row>
        <v-col>
          <v-sheet height="64" style="margin-left: 43%">
            <v-toolbar flat>
              <v-btn fab text small color="grey darken-2" @click="calendarPrv" :disabled="arrowCtrlFlag">
                <v-icon x-large> mdi-chevron-left </v-icon>
              </v-btn>
              <v-toolbar-title>
                <h2>{{this.canderTitle}}</h2>
              </v-toolbar-title>
              <v-btn fab text small color="grey darken-2" @click="calendarNext" :disabled="arrowCtrlFlag">
                <v-icon x-large> mdi-chevron-right </v-icon>
              </v-btn>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-sheet>
          <v-sheet height="700">
            <v-calendar ref="calendar" v-model="focus" color="primary" :events="events" :type="type"
              @click:event="showEvent" @click:date="btnClick($event)">
              <template v-slot:day="props">
                <template v-for="(ent, index) in notOfferEventsDateList">
                  <div :key="index" class="disable" v-if="ent == props.date" style="text-align: center">
                    提供無し
                  </div>
                </template>
              </template>
              <template v-slot:event="{ event }">
                <v-row>
                  <v-col style="text-align:center">
                    {{ event.name }}
                  </v-col>
                </v-row>
              </template>
            </v-calendar>
          </v-sheet>
          <MealLunchDialog ref="modalLunch" @reCalendar="calendarGet"></MealLunchDialog>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
  import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
  import RyouSelect from "../../components/formInput/RyouSelect";
  import MealLunchDialog from "./modules/MealLunchDialog.vue";
  import { postUploadRequest } from "@/utils/api";
  export default {
    name: "MealLunchSetting",
    components: {
      RyouBlackBtn,
      RyouSelect,
      MealLunchDialog,
    },
    data() {
      return {
        p2Form: true,
        inputRulesFile: [],
        focus: "",
        type: "month",
        canderTitle: "",//カレンダーのヘッダ
        mealDeadLineDay: "",//締め切りの日
        hasEventsDateList: [],//メニューが存在する日付["YYYY-MM-dd","YYYY-MM-dd",...]
        hasEventsDateDetailedDataList: [],//メニューが存在する詳細データ
        mealNames: [],//日付の食事名[食事一,食事二,...]
        events: [],//メニューが存在毎日のイベント[ある日の食事一,食事二,...]
        notOfferEventsDateList: [],//提供無し日付["YYYY-MM-dd","YYYY-MM-dd",...]
        notOfferEventsDateDetailedDataList: [],//提供無し日付詳細データ
        chosenFile: null,
        selectOptionValue: "",
        dynamicItems: [],
        colors: [
          "#FF9800",//オレンジ
          "#673AB7",//深紫
          "#4CAF50",//緑
          "#E91E63",//ピンク
          "#3F51B5",//インディゴ
          "#009688",//teal
          "#FF5722",//深オレンジ
          "#8BC34A",//light-green
          "#D32F2F",//red darken-2
          "#1565C0"//blue darken-3
        ],
        arrowCtrlFlag: false
      };
    },
    created() {
      this.initData();
    },
    mounted() {
      this.inputRulesFile.push(this.GlobalRules.required);
      this.canderTitle = this.initCanderValue(this.$refs.calendar.title);
    },
    watch: {
      selectOptionValue(value) {
        if (value != "") {
          this.calendarGet();
        }
      },
      canderTitle() {
        if (this.selectOptionValue != "") {
          this.calendarGet();
        }
      }
    },
    methods: {
      //日付をクリック
      btnClick(date) {

        this.canderTitle = date.year + "年" + date.month + "月";
        let getNowMonth = this.$refs.calendar.title.split("月 ");

        // 当月かどうかを判断
        if (date.month == getNowMonth[0]) {
          let DialogData = this.calendarDialogDataGet(date.date);

          if (DialogData) {
            // パラメータ1:ダイアログデータ、パラメータ2:物件グループID
            // パラメータ3:食事提供有無フラグ、パラメータ4:締め切りフラグ
            // パラメータ5:[食事区分&食事名]
            this.$refs.modalLunch.getInputValue(
              DialogData, this.selectOptionValue,
              true, date.date < this.mealDeadLineDay,
              this.mealNames);
          }
          else {
            DialogData = this.calendarDialogNotOfferDataGet(date.date);

            if (DialogData) {
              // パラメータ1:ダイアログデータ、パラメータ2:物件グループID
              // パラメータ3:食事提供有無フラグ、パラメータ4:締め切りフラグ
              // パラメータ5:[食事区分&食事名]
              this.$refs.modalLunch.getInputValue(
                DialogData, this.selectOptionValue,
                false, date.date < this.mealDeadLineDay,
                this.mealNames);
            } else {
              this.$refs.modalLunch.getInputValue(date.date);
            }
          }
        }
      },
      //イベントクリック
      showEvent(event) {
        let DialogData = this.calendarDialogDataGet(event.day.date);
        if (DialogData) {
          // パラメータ1:ダイアログデータ、パラメータ2:物件グループID
          // パラメータ3:食事提供有無フラグ、パラメータ4:締め切りフラグ
          // パラメータ5:[食事区分&食事名]
          this.$refs.modalLunch.getInputValue(
            DialogData, this.selectOptionValue,
            true, event.day.date < this.mealDeadLineDay,
            this.mealNames);
        }
        else {
          this.$refs.modalLunch.getInputValue(event.day.date);
        }
      },
      initData() {
        let params = {
          userId: this.$store.getters.getUserId,
          userClass: this.$store.getters.getUserClass,
        }
        //selectBoxで値を取る
        this.getRequest("/mealLunchSetting/buildGroupGet", params, this.$store.getters.getUserToken).then(data => {
          if (data.success) {
            this.dynamicItems = data.result;
          }
        });
      },
      //一括登録
      importFile() {

        var valid = this.$refs.p2Form.validate();
        if (valid) {
          let formData = new FormData();
          formData.append("file", this.chosenFile);

          let paramsSelect = this.selectOptionValue;
          if (paramsSelect == "") {
            paramsSelect = "〇";
          }

          let url = "/mealLunchSetting/fileInsertUpdate" + "/" + this.$store.getters.getUserId + "/" + paramsSelect;

          postUploadRequest(url, formData, this.$store.getters.getUserToken).then((resp) => {
            if (resp.success) {

              this.calendarGet();
            }
          });
        }
      },
      //カレンダーデータ取得
      calendarGet() {

        // データクリア
        this.mealNames = [];
        this.events = [];
        this.hasEventsDateList = [];
        this.hasEventsDateDetailedDataList = [];
        this.notOfferEventsDateList = [];
        this.notOfferEventsDateDetailedDataList = [];
        this.$(".v-calendar-weekly__day:has(div.disable)").removeClass("mask");
        this.$("div.disable").remove();

        if (this.selectOptionValue != null && this.selectOptionValue != "") {
          var that = this;

          let mealClassDeadLineParams = {
            buildGroupId: this.selectOptionValue
          };

          this.getRequest("/mealLunchSetting/mealClassGet", mealClassDeadLineParams, this.$store.getters.getUserToken).then(data => {
            // 食事区分取得
            if (data.success) {
              that.mealNames = data.result;
            }
          });

          this.getRequest("/mealLunchSetting/mealDeadLineGet", mealClassDeadLineParams, this.$store.getters.getUserToken).then(data => {
            // 食事締め切り日取得
            if (data.success) {
              that.mealDeadLineDay = data.result;
            }
          });

          //年月取得
          let titleYear = this.canderTitle.split("年")
          let titleMonth = titleYear[1].split("月")
          let calendarParams = {
            buildGroupId: this.selectOptionValue,
            currentYM: titleYear[0] + "-" + titleMonth[0]
          };

          this.arrowCtrlFlag = true;

          this.getRequest("/mealLunchSetting/calendarGet", calendarParams, this.$store.getters.getUserToken).then(data => {
            if (data.success) {
              // 現在の月を循環
              for (let dateIndex = 0; dateIndex < data.result.length; dateIndex++) {

                //取得当日
                let dateItem = data.result[dateIndex];
                // 取得当日(Key,Value)
                for (let dateKey in dateItem) {

                  //取得当日データ
                  let dateData = dateItem[dateKey];
                  // 取得当日データあり
                  if (dateData.length != 0) {
                    // データが存在する日付
                    if (dateData[0].offer_flg == "1") {
                      //食事提供あり結果セット
                      if (that.hasEventsDateList.indexOf(dateKey) < 0) {
                        that.hasEventsDateList.push(dateKey);
                        that.hasEventsDateDetailedDataList.push(dateItem);
                      }
                    } else if (dateData[0].offer_flg == "0") {
                      //食事提供なし結果セット
                      if (that.notOfferEventsDateList.indexOf(dateKey) < 0) {
                        that.notOfferEventsDateList.push(dateKey);
                        that.notOfferEventsDateDetailedDataList.push(dateItem);
                      }
                    }
                  }
                }
              }

              this.getValue();
            }
            this.arrowCtrlFlag = false;
          });
        }
      },
      //カレンダー、ポップアップ、データ取得
      calendarDialogDataGet(value) {
        for (let hedddIndex = 0; hedddIndex < this.hasEventsDateDetailedDataList.length; hedddIndex++) {

          let hedddItem = this.hasEventsDateDetailedDataList[hedddIndex];

          for (let hedddKey in hedddItem) {
            if (hedddKey == value) {
              return hedddItem;
            }
          }
        }
      },
      //カレンダー、ポップアップ、データ取得(提供なし)
      calendarDialogNotOfferDataGet(value) {
        for (let noedddIndex = 0; noedddIndex < this.notOfferEventsDateDetailedDataList.length; noedddIndex++) {

          let noedddItem = this.notOfferEventsDateDetailedDataList[noedddIndex];

          for (let noedddKey in noedddItem) {
            if (noedddKey == value) {
              return noedddItem;
            }
          }
        }
      },
      //カレンダーヘッドの初期化時間
      initCanderValue(tilte) {
        let titleList = tilte.split("月 ")
        let newTitile = titleList[1] + "年" + titleList[0] + "月";

        return newTitile;
      },
      //カレンダーの来月
      calendarNext() {
        this.$refs.calendar.next();

        setTimeout(() => {
          this.canderTitle = this.initCanderValue(this.$refs.calendar.title);
        }, 100);

        this.getValue();
      },
      //カレンダーの前の月
      calendarPrv() {
        this.$refs.calendar.prev();

        setTimeout(() => {
          this.canderTitle = this.initCanderValue(this.$refs.calendar.title);
        }, 100);

        this.getValue();
      },
      //カレンダーデータのロードが完了しました。
      getValue() {
        // データが存在する日食、事区分表示
        for (let dateIndex = 0; dateIndex < this.hasEventsDateDetailedDataList.length; dateIndex++) {

          //当日の食事は区分表示
          for (let menuCount = 0; menuCount < this.mealNames.length; menuCount++) {

            let hasEventsDateDetailedDataItem = this.hasEventsDateDetailedDataList[dateIndex];

            for (let hedddiKey in hasEventsDateDetailedDataItem) {

              let hasEventsDateDetailedDataItemValue = hasEventsDateDetailedDataItem[hedddiKey];
              for (let hedddivIndex = 0; hedddivIndex < hasEventsDateDetailedDataItemValue.length; hedddivIndex++) {

                if (this.mealNames[menuCount].meal_class == hasEventsDateDetailedDataItemValue[hedddivIndex].meal_class) {

                  if (hedddiKey < this.mealDeadLineDay) {
                    this.events.push({
                      name: hasEventsDateDetailedDataItemValue[hedddivIndex].menu,
                      start: hedddiKey,
                      color: "#795548",
                      timed: false,
                    });
                  }
                  else {
                    this.events.push({
                      name: hasEventsDateDetailedDataItemValue[hedddivIndex].menu,
                      start: hedddiKey,
                      color: this.colors[menuCount],
                      timed: false,
                    });
                  }

                  break;
                } else {

                  if (hedddivIndex == hasEventsDateDetailedDataItemValue.length - 1) {
                    if (hedddiKey < this.mealDeadLineDay) {
                      this.events.push({
                        name: "",
                        start: hedddiKey,
                        color: "#795548",
                        timed: false,
                      });
                    }
                    else {
                      this.events.push({
                        name: "",
                        start: hedddiKey,
                        color: this.colors[menuCount],
                        timed: false,
                      });
                    }
                  }

                }
              }
            }
          }
        }

        setTimeout(() => {
          // disableを含む要素を見つけて、スタイルを追加します
          this.$(".v-calendar-weekly__day:has(div.disable)").addClass("mask");
        }, 100);
      },
    },
  };
</script>

<style lang="scss">
  .noPaddingBtm {
    padding-bottom: 0px;
  }

  .ryouSelectStyle {
    width: 250px;
    height: 40px;
  }

  .OfferTitle {
    padding: 0px 55px;
  }

  .mask {
    box-sizing: border-box;
    border: 1px solid #9E9E9E !important;
    background-color: #bebebe !important;
  }
</style>